import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { IPrintOptions } from '@modeso/types__aumico-lib-annualreport-be';
import { UntilDestroy } from '@ngneat/until-destroy';
import { cloneDeep } from 'lodash-es';
import { IFinancialTableData, IOptions, ISectionData } from 'projects/aumico-lib-annualreport-fe/src/public-api';

@UntilDestroy()
@Component({
    selector: 'account-proof-swiss-display-component',
    templateUrl: 'account-proof-swiss-display.component.html',
    styleUrls: ['account-proof-swiss-display.component.scss'],
    providers: [],
})
export class AccountProofSwissDisplayComponent implements OnInit {
    colCount: number;
    ngOnInit(): void {}

    public finTableData: IFinancialTableData[];

    private sectionData: ISectionData | undefined;
    @Input() set mappingData(value: ISectionData | undefined) {
        if (value == null) {
            return;
        }
        this.sectionData = cloneDeep<ISectionData>(value);
        this.finTableData = [this.sectionData.data as IFinancialTableData];
    }
    @Input() noPreviousData: boolean;
    @Input() set printOptions(value: IPrintOptions | undefined) {
        if (value != null) {
            this.showRatios = false; // value.displayOptions.showRatios;
            this.showNotes = value.displayOptions.showNotes;
            this.textColor = value.styleOptions.textColor;
            this.backgroundColor = value.styleOptions.backgroundColor;
            this.backgroundColorPY = value.styleOptions.backgroundColorPY;
            this.tableHeaderColor = value.styleOptions.tableHeaderColor;
            this.tableFooterColor = value.styleOptions.tableFooterColor;
        }
    }
    @Input() set pdfOptions(value: IOptions | undefined) {
        if (value != null) {
            this.options = value;
        }
        this.colCount = 3;
        if (this.showRatios && this.noPreviousData) {
            this.colCount = this.colCount + 1;
        }
        if (this.showRatios && !this.noPreviousData) {
            this.colCount = this.colCount + 2;
        }
        if (this.options.printClosingValueTotalsInSeparateColumn) {
            this.colCount = this.colCount + 2;
        } else {
            this.colCount = this.colCount + 1;
        }
    }

    @Input() activeLocale: string;

    textColor: string;
    backgroundColor: string;
    backgroundColorPY: string;
    tableFooterColor: string;
    tableHeaderColor: string;
    showRatios: boolean;
    showNotes: boolean;
    options: IOptions;
    styles: string[] = [];

    @HostBinding('style.--style-1') style1 = 'none';
    @HostBinding('style.--style-2') style2 = 'none';
    @HostBinding('style.--style-3') style3 = 'none';
    @HostBinding('style.--style-4') style4 = 'none';
    @HostBinding('style.--style-5') style5 = 'none';
    @HostBinding('style.--style-6') style6 = 'none';
    @HostBinding('style.--style-7') style7 = 'none';
    @HostBinding('style.--style-8') style8 = 'none';
    @HostBinding('style.--style-9') style9 = 'none';
    @HostBinding('style.--style-10') style10 = 'none';

    constructor() {
        this.styles.push('upper-alpha');
        this.styles.push('upper-roman');
        this.styles.push('decimal');
        this.styles.push('decimal');
        this.styles.push('decimal');
        this.styles.push('decimal');
        this.styles.push('decimal');
        this.styles.push('decimal');
        this.styles.push('decimal');
        this.styles.push('decimal');

        for (let i = 0; i < this.styles.length; i++) {
            this['style' + (i + 1)] = this.styles[i];
        }
    }
}
